// extracted by mini-css-extract-plugin
export default {"rates_container":"RatesContainer_rates_container__KCQKT"};